import { useEffect } from 'react'
import { constants } from './Constants'
import { Box, Typography } from '@mui/material'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import {
  setUnidentifiedPatientDetails,
  selectUnidentifiedPatientDetails,
} from './ProrithmSlice'

const UnidentifiedPatient = () => {
  const dispatch = useAppDispatch()
  const unidentifiedPatientDetails = useAppSelector(
    selectUnidentifiedPatientDetails
  )

  const patientDetails = [
    {
      label: constants?.firstName,
      value: unidentifiedPatientDetails?.firstName,
    },
    { label: constants?.lastName, value: unidentifiedPatientDetails?.lastName },
    { label: constants?.age, value: unidentifiedPatientDetails?.age },
    { label: constants?.gender, value: unidentifiedPatientDetails?.gender },
  ]

  useEffect(() => {
    return () => {
      // Reset previous unidentified patient details
      if (unidentifiedPatientDetails) {
        dispatch(setUnidentifiedPatientDetails(null))
      }
    }
  }, [dispatch, unidentifiedPatientDetails])

  return (
    <>
      {unidentifiedPatientDetails && (
        <Box margin={2}>
          <Typography fontWeight='bold' variant='h5'>
            {constants?.patientDetails}:
          </Typography>
          {patientDetails?.map(({ label, value }) => (
            <Typography key={label}>
              <strong>{label}:&nbsp;</strong>
              {value}
            </Typography>
          ))}
        </Box>
      )}
    </>
  )
}

export default UnidentifiedPatient
